import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  CREATE_CARD_MOVE_FORM,
  RETURN_ONSHORE_MODAL_ID,
} from "features/planner/planner.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import { returnEmployeeOnSubmit } from "features/planner/planner.actions";
import ReturnOnshoreForm from "features/planner/components/CreateCardMove/ReturnOnshoreForm";
import CreateCardMoveTopContent from "features/planner/components/CreateCardMove/CreateCardMoveTopContent";

class ReturnOnshoreModal extends PureComponent {
  render() {
    const { dispatchReturnEmployeeOnSubmit } = this.props;

    return (
      <SimpleFormModal
        submitText="Save"
        title="Return onshore"
        component={ReturnOnshoreForm}
        Tabs={CreateCardMoveTopContent}
        onSubmit={dispatchReturnEmployeeOnSubmit}
        modalId={RETURN_ONSHORE_MODAL_ID}
        DialogProps={{
          fullWidth: true,
        }}
        form={{
          form: CREATE_CARD_MOVE_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(null, {
    dispatchReturnEmployeeOnSubmit: returnEmployeeOnSubmit,
  }),
)(ReturnOnshoreModal);
